export const nonScheduleSessionVerificationTableHeader = () => [
  {
    headerName: 'Sl No.',
    field: 'slNo',
    width: 90,
  },
  {
    headerName: 'Student / Batch',
    field: 'studentBatch',
    width: 200,
  },
  {
    headerName: 'Course',
    field: 'course',
    width: 180,
  },
  {
    headerName: 'Subject',
    field: 'subject',
    width: 180,
  },
  {
    headerName: 'Session Date',
    field: 'sessionDate',
    width: 160,
  },
  {
    headerName: 'Time',
    field: 'time',
    width: 120,
  },
  {
    headerName: 'Attendance Type',
    field: 'attendanceType',
    width: 160,
  },
  {
    headerName: 'Fee per Session',
    field: 'feePerSession',
    width: 160,
  },
  {
    headerName: 'Trainer Payment',
    field: 'trainerPayment',
    width: 160,
  },
  {
    headerName: 'Lessons',
    field: 'lessons',
    width: 200,
  },
  {
    headerName: 'Remarks',
    field: 'remarks',
    width: 200,
  },
  {
    headerName: 'Timestamp',
    field: 'timestamp',
    width: 180,
  },
  {
    headerName: 'Tutor',
    field: 'tutor',
    width: 180,
  },
  {
    headerName: 'Attendance Verification',
    field: 'attendanceVerification',
    width: 220,
  },
  {
    field: 'Invoice',
    headerName: 'Action',
    type: 'action',
    actionType: '',
    icon: 'bitcoin-icons:verify-filled',
    actionKey: 'Attendance Details',
    width: 140,
    buttonName: 'Verify',
  },
];
